import type { RouteObject } from "react-router"

import { RootPath } from "@/models/route"

import { Settings } from "./components/settings/settings"

export const settingsRoutes: RouteObject[] = [
  {
    path: RootPath.Settings,
    element: <Settings />,
  },
]
